export default "__VITE_ASSET__HlYBzoKU__"